export default __webpack_public_path__ + "static/media/serviciosAlarma3.05a46d85.png";